export const links = [
  { value: "Goals", label: "Goals" },
  { value: "Chat", label: "Chat" },
  { value: "Diary", label: "Diary" },
  { value: "Wallet", label: "Wallet" },
  { value: "TokenPay", label: "TokenPay" },
  { value: "Store", label: "Store" },
];



// WEBPACK FOOTER //
// ./src/screens/BespokeExplore/constants/selections.js